<template>
    <div>
        <template>
            <CommonTreePannel
                    :leftData="leftData"
                    :columns="selectPanelColumns"
                    :rightData="value"
                    @selectValues="handleValues"
                    :disabled="disabled"
            />
        </template>
    </div>
</template>
<script>
import CommonTreePannel from '@/components/common/CommonTreePannel'
export default {
  components: {
    CommonTreePannel
  },
  props: ['leftData', 'selectPlaceholder', 'selectPanelColumns', 'value', 'disabled'],
  data() {
    return {
      selectReginValue: [],
      selectData: undefined
    }
  },
  methods: {
    handleValues(data) {
      this.$emit('input', data)
    }
  }
}
</script>
